// extracted by mini-css-extract-plugin
export default {"h5":"h5-module___h5___fd9d8988"};